import { render } from "./AgeBarChart.vue?vue&type=template&id=05a872ac"
import script from "./AgeBarChart.vue?vue&type=script&lang=js"
export * from "./AgeBarChart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AgeBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05a872ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05a872ac', __exports__)) {
    console.log('reload')
    api.reload('05a872ac', __exports__)
  }
  
  module.hot.accept("./AgeBarChart.vue?vue&type=template&id=05a872ac", () => {
    console.log('re-render')
    api.rerender('05a872ac', render)
  })

}


export default __exports__